import configureStore from "../../modules/landing-header/store/configure-store";

export const BB = window.BB;
export const buildLandingStore = () => configureStore(window.__INITIAL_STATE__);
